<template><span class="status-tag" :class="statusClass">{{ label || value || '—' }}</span></template>

<script>
export default {
  name: 'StatusTag',
  props: { value: { type: String, default: '' }, label: { type: String, default: '' } },
  computed: {
    statusClass () { return String(this.value).toLowerCase().replace(/[^a-z0-9_-]/g, '-') }
  }
}
</script>
